import clientDeepLinks from "@/utils/clientDeepLinks";
import { ossFullUrl } from "@/utils/getFullWebCdnUrl";
import handleDeepLink from "@/utils/handleDeepLink";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import TaskCard from "@/containers/activities/rewards/TaskCard";

export default function TeslaActivity() {
	const { t } = useTranslation("activities");
	const router = useRouter();

	const handleTeslaActivityClick = () => {
		const url = `${window.location.origin}/${router.locale}/activities/stock-rebate?hidden_navigation_bar=1&status_bar=1`;
		const deepLink = clientDeepLinks.webview(url);
		handleDeepLink(deepLink);
	};

	return (
		<TaskCard
			done={false}
			title={t("earn-tesla-stocks-together-title")}
			desc={t("earn-tesla-stocks-together-desc")}
			iconDark={ossFullUrl("/activities/tesla-liwu-dark.png")}
			iconLight={ossFullUrl("/activities/tesla-liwu-white.png")}
			btnText={""}
			onClick={handleTeslaActivityClick}
		/>
	);
}
